module.exports = __webpack_public_path__ + "static/banblog-c0f1e0d66fa7ff7c2fc916ea9a05fa2e.svg";